import Cookies from "js-cookie"
import { planningValidation } from "@/utils"
import { fetchPlannings } from "@/api/plannings"

const app = {
  state: {
    sidebar: {
      opened: !+Cookies.get("sidebarStatus"),
      withoutAnimation: false
    },
    device: "desktop",
    modal: {
      opened: true,
      name: null,
      payload: null,
      closable: true
    },
    validationBanner: {
      isApproved: !!+Cookies.get("planning_validation"),
      open: false,
      // valid: false,
      message: planningValidation.message
    },
    cookiesBanner: {
      open: false,
      isApproved: !!+Cookies.get("cookies_approved")
    },
    scroller: null
  },
  mutations: {
    OPEN_VALIDATION_BANNER: (state, payload) => {
      state.validationBanner.open = payload
    },
    SET_PLANNING_VALIDATION_STATUS: (state, payload) => {
      state.validationBanner.isApproved = payload
    },
    OPEN_COOKIES_BANNER: (state, payload) => {
      state.cookiesBanner.open = payload
    },
    TOGGLE_SIDEBAR: state => {
      if (state.sidebar.opened) {
        Cookies.set("sidebarStatus", 1)
      } else {
        Cookies.set("sidebarStatus", 0)
      }
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set("sidebarStatus", 1)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },

    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },

    // Ovelay modal mutations
    CLOSE_MODAL: state => {
      state.modal.opened = false
    },
    OPEN_MODAL: state => {
      state.modal.opened = true
    },
    SET_CLOSABLE_MODAL: (state, closable) => {
      state.modal.closable = closable
    },
    SET_CURRENT_MODAL: (state, currentModal) => {
      state.modal.name = currentModal
    },
    SET_CURRENT_MODAL_PAYLOAD: (state, payload) => {
      state.modal.payload = payload
    },
    // app scroller
    SET_SCROLLER: (state, scroller) => {
      state.scroller = scroller
    }
  },
  actions: {
    toggleSideBar: ({ commit }) => {
      commit("TOGGLE_SIDEBAR")
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit("CLOSE_SIDEBAR", withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit("TOGGLE_DEVICE", device)
    },
    // Ovelay modal actions
    // NOTE:
    // as we don't want to expose SET_CURRENT_MODAL
    // there is no need to make an action for it
    openModal(
      { commit, rootGetters },
      { name, payload = null, closable = true }
    ) {
      // only open modal if it's already closed
      if (!rootGetters.modal.opened) {
        commit("OPEN_MODAL")
      }
      commit("SET_CURRENT_MODAL", name)
      commit("SET_CLOSABLE_MODAL", closable)
      commit("SET_CURRENT_MODAL_PAYLOAD", payload)
    },
    closeModal({ commit }) {
      commit("CLOSE_MODAL")
      commit("SET_CURRENT_MODAL", null)
      commit("SET_CURRENT_MODAL_PAYLOAD", null)
    },
    /**
     * Start showing banner on 20th (until 10th) of current
     * month if next month's planning isn't approved
     */
    openValidationBanner({ commit, state }) {
      if (!state.validationBanner.isApproved) {
        const { dates } = planningValidation
        if (dates) {
          commit("OPEN_VALIDATION_BANNER", true)

          fetchPlannings().then(res => {
            const _date = dates.NEXT ? dates.NEXT : dates.CURRENT
            if (_date) {
              const key = _date.toISOString().slice(0, 7)
              const isApproved = res[key].month_approved

              if (isApproved) {
                // if planning is approved we set a cookie
                // that will expire on the 19th of next month
                _date.setDate(19)
                Cookies.set("planning_validation", 1, {
                  expires: _date
                })
                commit("SET_PLANNING_VALIDATION_STATUS", true)
              }
            }
          })
        }
      }
    },
    /**
     * Close planning validation alert banner
     * and set cookie if planning isn't approved
     */
    closeValidationBanner({ commit, state }) {
      commit("OPEN_VALIDATION_BANNER", false)
      if (!state.validationBanner.isApproved) {
        // if planning is not approved we set a
        // session cookie, so that the warning
        // shows up only once every session
        Cookies.set("planning_validation", 1)
      }
    },
    /**
     * Open Cookies banner if cookies haven't been
     * approved yet
     */
    openCookiesBanner({ commit, state }) {
      if (!state.cookiesBanner.isApproved) {
        commit("OPEN_COOKIES_BANNER", true)
      }
    },
    /**
     * Set a session cookie and close cookies banner
     */
    closeCookiesBanner({ commit }) {
      Cookies.set("cookies_approved", 1)
      commit("OPEN_COOKIES_BANNER", false)
    },
    /**
     * Set a cookie that expires after 365 days
     * and close cookies banner
     */
    acceptCookies({ commit }) {
      Cookies.set("cookies_approved", 1, { expires: 365 })
      commit("OPEN_COOKIES_BANNER", false)
    },
    /**
     * Remove all cookies and close banner
     */
    removeCookies({ commit }) {
      commit("OPEN_COOKIES_BANNER", false)
      const cookiesKeys = Object.keys(Cookies.get())
      for (const key of cookiesKeys) {
        Cookies.remove(key)
      }
    }
  }
}

export default app
